/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListAssistantsSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type ListAssistantsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListAssistantsSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListAssistantsSecurity$outboundSchema: z.ZodMiniType<
  ListAssistantsSecurity$Outbound,
  ListAssistantsSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listAssistantsSecurityToJSON(
  listAssistantsSecurity: ListAssistantsSecurity,
): string {
  return JSON.stringify(
    ListAssistantsSecurity$outboundSchema.parse(listAssistantsSecurity),
  );
}

/** @internal */
export type ListAssistantsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListAssistantsRequest$outboundSchema: z.ZodMiniType<
  ListAssistantsRequest$Outbound,
  ListAssistantsRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function listAssistantsRequestToJSON(
  listAssistantsRequest: ListAssistantsRequest,
): string {
  return JSON.stringify(
    ListAssistantsRequest$outboundSchema.parse(listAssistantsRequest),
  );
}
